import {Slider, styled} from '@mui/material';
import {CustomSliderProps} from './types';

export const CustomSlider = styled(Slider)<CustomSliderProps>(({theme, $activeIndex}) => ({
	'& .MuiSlider-thumb': {
		width: 16,
		height: 16,
	},
	'& .MuiSlider-rail': {
		backgroundColor: '#CCC',
	},
	'& .MuiSlider-mark': {
		width: 16,
		height: 16,
		backgroundColor: '#FFFFFF',
		borderRadius: '100%',
		border: '1px solid #CCC',
		opacity: 1,
		transform: 'translate(-50%, -50%)',
		'&.MuiSlider-markActive': {
			backgroundColor: theme.palette.primary.main,
			border: `1px solid ${theme.palette.primary.main}`,
		},
	},
	'& .MuiSlider-markLabel': {
		color: theme.palette.text.secondary,
		fontWeight: 400,

		[`&[data-index="4"]`]: {
			translate: '-25%',
		},

		[`&[data-index="0"]`]: {
			translate: '25%',
		},

		[`&[data-index="${$activeIndex}"]`]: {
			fontWeight: 600,
			...($activeIndex === 4 && {translate: '-25%'}),
			...($activeIndex === 0 && {translate: '25%'}),
		},
	},
}));
